import { Box, Collapse, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import type { ComparisonItemSourceFields, ComparisonItem } from '../../../../../types/BaselineMeasurements';
import { ComparisonEventsListRowDetailRow } from './ComparisonEventsListRowDetailRow';
import type { Connection } from '../../../../../types';

type ComparisonEventsListRowDetailProps = {
  connectionId: Connection['connectionId'] | undefined;
  open: boolean;
  item: ComparisonItem;
  excludeFields?: Array<keyof ComparisonItemSourceFields>;
};

const detailHeaders = ['Field', 'Event', 'Insurer', 'Action'];

export const ComparisonEventsListRowDetail = ({
  connectionId,
  open,
  item,
  excludeFields = ['id', 'externalId', 'sourceType'],
}: ComparisonEventsListRowDetailProps) => {
  const eventFields = item.eventSource;

  return (
    <TableRow sx={{ bgcolor: 'grey.50' }}>
      <TableCell sx={{ padding: 0, bgcolor: 'grey.50' }} colSpan={6}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box sx={{ margin: 0, bgcolor: 'grey.50', maxWidth: 'md', mx: 'auto' }}>
            <Table size="small" aria-label="differencies" sx={{ padding: 0 }}>
              <TableHead sx={{ pt: 0 }}>
                <TableRow sx={{ bgcolor: '#f3f4f6', pt: 0 }}>
                  {detailHeaders.map((header, index) => (
                    <TableCell key={index} sx={{ border: 'none', px: 1, py: 0.1 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 'normal',
                          color: '#111827',
                        }}
                      >
                        {header}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(Object.keys(eventFields) as Array<keyof ComparisonItemSourceFields>)
                  .filter(field => !excludeFields.includes(field))
                  .map(field => {
                    return (
                      <ComparisonEventsListRowDetailRow
                        key={field}
                        connectionId={connectionId}
                        item={item}
                        field={field}
                      />
                    );
                  })}
              </TableBody>
            </Table>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};
